/**
 * Calculate distance between two points using Haversine formula
 */
export function calculateDistance(lat1, lon1, lat2, lon2) {
  const R = 6371; // Earth's radius in kilometers
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLon = ((lon2 - lon1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c;
  return distance;
}

/**
 * Get user's current location with best available accuracy
 */
export function getCurrentLocation(targetAccuracy = 50, maxWait = 6000) {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error("Geolocation is not supported by this browser."));
      return;
    }

    let bestPosition = null;
    let watchId;
    let timeoutId;

    const finish = () => {
      if (watchId) navigator.geolocation.clearWatch(watchId);
      if (timeoutId) clearTimeout(timeoutId);

      if (bestPosition) {
        resolve({
          latitude: bestPosition.coords.latitude,
          longitude: bestPosition.coords.longitude,
          accuracy: bestPosition.coords.accuracy,
        });
      } else {
        reject(new Error("Could not get location"));
      }
    };

    timeoutId = setTimeout(finish, maxWait);

    watchId = navigator.geolocation.watchPosition(
      (position) => {
        if (!bestPosition || position.coords.accuracy < bestPosition.coords.accuracy) {
          bestPosition = position;
        }
        if (position.coords.accuracy <= targetAccuracy) {
          finish();
        }
      },
      (error) => {
        if (watchId) navigator.geolocation.clearWatch(watchId);
        if (timeoutId) clearTimeout(timeoutId);

        switch (error.code) {
          case error.PERMISSION_DENIED:
            reject(new Error("Location access denied by user."));
            break;
          case error.POSITION_UNAVAILABLE:
            reject(new Error("Location information is unavailable."));
            break;
          case error.TIMEOUT:
            reject(new Error("Location request timed out."));
            break;
          default:
            reject(new Error("An unknown error occurred."));
            break;
        }
      },
      { enableHighAccuracy: true, maximumAge: 0 }
    );
  });
}

/**
 * Sort mosques by distance from user location using Firebase GeoPoint coordinates
 */
export function sortMasajidByDistance(masajid, userLat, userLng) {
  return masajid
    .map((masjid) => {
      const geoPoint = masjid.coordinates;
      if (geoPoint?._latitude != null && geoPoint?._longitude != null) {
        const distance = calculateDistance(
          userLat,
          userLng,
          geoPoint._latitude,
          geoPoint._longitude
        );
        return { ...masjid, distance };
      }
      return { ...masjid, distance: Infinity };
    })
    .sort((a, b) => a.distance - b.distance);
}